module.exports = __webpack_public_path__ + "static/media/sample_manage_trucks.f445adf4.csv";